<div>
  <!-- <div style="padding: 20px; color: white;">
    <h2 >OUR PARTNERSHIP PROGRAMMES</h2>
    <p>Our partners range from global enterprises to startups and entrepreneurs. We’re proud to collaborate with Affiliates as Partners to power the tomorrows of millions of commerce businesses.</p>
  </div> -->
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" [style.height]="item.height" [ngStyle.lt-md]="{'height': item.heightMob}"  class="cards-container">
    <mat-card class="partner-card" (mouseenter)="hovered = true" (mouseleave)="hovered = false">
      <div class="video-container">
        <video #videoPlayer [src]="serverPath+img.img | safe: 'resourceUrl'"  autoplay loop ></video>

        <button *ngIf="hovered" mat-icon-button class="pause-button" (click)="togglePlay(videoPlayer)">
          <mat-icon>{{ videoPlayer?.paused ? 'play_arrow' : 'pause' }}</mat-icon>
        </button>
      </div>

      <div class="card-content">
        <h2 [style.font-size]="item.customField18"
        [ngStyle.lt-md]="{ 'font-size': item.customField17 }">{{ img.customField1 }}</h2>
        <p>
          <calsoft-editor-text  [text]="img?.customField4">
          </calsoft-editor-text>
        </p>
      </div>
    </mat-card>

  </div>
</div> 